import { HomeProductsListDTO, HomeSlotBase, HomeSlotType, mapHomeSlotBase } from '../../../../server';

export type HomeTargetedCarouselValue = HomeSlotBase & {
    type: typeof HomeSlotType.TargetedCarousel;
};

export const mapHomeTargetedCarousel = (dto: HomeProductsListDTO): HomeTargetedCarouselValue => ({
    ...mapHomeSlotBase(dto),
    type: HomeSlotType.TargetedCarousel,
});
